<script setup>
import { computed, onMounted, ref } from 'vue';
//import { isProxy, toRaw, getCurrentInstance, onMounted, ref } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import PageHeader from "@/Components/PageHeader.vue";
import CardBoxWidget from "@/Components/CardBoxWidget.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import BaseIcon from "@/Components/BaseIcon.vue";
import {
    mdiAccountMultiple,
    mdiCartOutline,
    mdiChartTimelineVariant,
    mdiMonitorCellphone,
    mdiReload,
    mdiGithub,
    mdiChartPie,
    mdiMagnify,
    mdiDownload,
    mdiGoogleClassroom,
    mdiBook,
    mdiPaperclip,
    mdiEye,
    mdiPrinter,
    mdiCalendarRangeOutline,
    mdiCalendarAccount,
    mdiFileDocument,
    mdiCalendarCheckOutline,
    mdiClockCheck,
    mdiClockRemove,
    mdiMinusThick,
    mdiCloseThick,
    mdiCheckBold,
    mdiClockTimeThreeOutline,
    mdiAccountStar,
    mdiCashFast,
    mdiClockTimeEight,
    mdiChevronRight,
    mdiCogOutline,
    mdiPlus,
    mdiChatProcessingOutline,
    mdiHelp,
    mdiStarOutline,
    mdiStarShootingOutline,
    mdiChatQuestionOutline,
    mdiBookAccountOutline

} from "@mdi/js";
import CardBoxModal from "@/Components/CardBoxModal.vue";
import CardBoxModalPopup from "@/Components/CardBoxModalPopup.vue";
import constanteApi from "@/conf-global.js";
import { Inertia } from '@inertiajs/inertia';
//import ImageSlider from '@/Components/ImageSlider.vue'
//import $ from 'jquery';
import SectionTitleLineWithButton from "@/Components/SectionTitleLineWithButton.vue";
import SectionTitleLineWithButtonUnens from "@/Components/SectionTitleLineWithButtonUnens.vue";
import CardBoxCourse from "@/Components/CardBoxCourse.vue";

import * as chartConfig from "@/Components/Charts/radarchart.config.js";// <-- LRR Se usa radarchart  y no chart.config.js que para linear
//import LineChart from "@/Components/Charts/LineChart.vue";
import RadarChart from "@/Components/Charts/RadarChart.vue";// Example <-- cambiar a sólo RadarChart y no Example
import CardBox from "@/Components/CardBox.vue";
import UnensNavLink from '@/Components/NavLink.vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';// <-- https://splidejs.com/integration/vue-splide/

/* const props = defineProps({
    
}); */

/* const slides = [
    'https://images.unsplash.com/photo-1544427920-c49ccfb85579?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1422&q=80',
    'https://images.unsplash.com/photo-1544144433-d50aff500b91?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80'
    //'https://source.unsplash.com/random/800x400?i=1',
    //'https://source.unsplash.com/random/800x400?i=2',
    //'https://source.unsplash.com/random/800x400?i=3',
    //'https://source.unsplash.com/random/800x400?i=4',
    //'https://source.unsplash.com/random/800x400?i=5',
    //'https://source.unsplash.com/random/800x400?i=6',
] */

// Gráfica
/*     const chartData = ref(null);

    const fillChartData = () => {
    chartData.value = chartConfig.sampleChartData();
    };
 */
/*    onMounted(() => {
   fillChartData();
   }); */
//console.log(chartData)

/*     const listarFiles = (criterio, buscar) => {
        //const ruta = 'fileforlevel-' + props.ruta// + '?criterio=' + criterio + '&buscar=' + buscar
        const ruta = 'fileforlevel-file-filesforleve'// + '?criterio=' + criterio + '&buscar=' + buscar

        Inertia.get(route(ruta, {
            'criterio': criterio,
            'buscar': buscar
        }
        ))

        buscarCriterio.value = ''
        //}
    } */



// listar documentos
//const confGlobal = props.connstantes
const isModalFiles = ref(true)

onMounted(() => {
    listarMark()
    listarChartCalification()
    listarFilesForLevel()
    listarAdmisionPuntaje()
    listarTareas()
    getDataAsistencia()
});

/**
 * Get asistencia
 */
const cantTardanzas = ref(0)
const cantFaltas = ref(0)
const arrayAsistencia = ref(null)
const getDataAsistencia = () => {
    //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    /* let url = '/asistenciacolaborador/getfordashboard';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayAsistencia.value = respuesta.datalist// El return directo del array trae otros datos que generan error para el chart
        console.log(arrayAsistencia.value);
    }).catch(function (error) {
        console.log(error);
    }); */
}

/* onMounted(() => {
    listarChartCalification()
}); */
const chartCalifications = ref(null)// <-- Estaba en Array y generaba error con un labels y datasets adicionales
const chartSelectCiclo = ref(null);
const publicarNotas = ref(false);
const listarChartCalification = (ref_ciclo = '', origin_type = 'dash_student') => {
    //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    /* let url = '/calification/grafica' + '?ref_ciclo=' + ref_ciclo + '&origin_type=' + origin_type;
    
    if (ref_ciclo) {
        chartCalifications.value = null // <-- Limpiar value si se vuelve a consultar y no dejarlo en array
    }

    axios.get(url).then(function (response) {
        let respuesta = response.data;
        chartCalifications.value = respuesta.datachart// El return directo del array trae otros datos que generan error para el chart
        chartSelectCiclo.value = respuesta.refciclo
        publicarNotas.value = respuesta.publicarnotas
        console.log('B: ' + ref_ciclo)
        //console.log(chartCalifications.value);
        //console.log(chartSelectCiclo.value);
    }).catch(function (error) {
        console.log(error);
    }); */
}

const filesForLevel = ref([])
const listarFilesForLevel = () => {
    let url = '/file/listfilesforlevel';
    /* axios.get(url).then(function (response) {
        var respuesta = response.data;
        filesForLevel.value = respuesta.files;
        //console.log(filesForLevel.value);
    }).catch(function (error) {
        console.log(error);
    }); */
}

const haveEAP = ref(0)
const arrayAdmisionPuntaje = ref([])
const listarAdmisionPuntaje = () => {
    let url = '/admisionpuntaje/dashboard';
    /* axios.get(url).then(function (response) {
        var respuesta = response.data;
        arrayAdmisionPuntaje.value = respuesta.admisionpuntajes;
        haveEAP.value = respuesta.haveEAP;
        //console.log(filesForLevel.value);
    }).catch(function (error) {
        console.log(error);
    }); */
}

const countTareaWithOutResp = ref(0)
const arrayTareas = ref([])
const listarTareas = () => {
    let url = '/task/dashboard';
    /* axios.get(url).then(function (response) {
        var respuesta = response.data;
        arrayTareas.value = respuesta.tareas;
        countTareaWithOutResp.value = respuesta.countTareaWithOutResp;
        //console.log(arrayTareas.value);
        //console.log(countTareaWithOutResp.value);
    }).catch(function (error) {
        console.log(error);
    }); */
}

const studentActives = ref(0)
const studentInactives = ref(0)
const studentNews = ref(0)
const studentOlds = ref(0)
const studentTotal = ref(0)

const studentFinanOk = ref(0)
const studentFinanKo = ref(0)
onMounted(() => {
    let url = '/tercero/count';
    /* axios.get(url).then(function (response) {
        var respuesta = response.data;
        studentActives.value = respuesta.studentActives;
        studentInactives.value = respuesta.studentInactives;
        studentNews.value = respuesta.studentNews;
        studentOlds.value = respuesta.studentOlds;
        studentTotal.value = respuesta.studentTotal;
        //console.log(filesForLevel.value);
    }).catch(function (error) {
        console.log(error);
    }); */
});

const arrayMarks = ref([])
const asistenciaHoy = ref(null)
const conductaSemanal = ref(null)
const listarMark = () => {
    let url = '/mark/dashboard';
    /* axios.get(url).then(function (response) {
        var respuesta = response.data;
        arrayMarks.value = respuesta.data;
        asistenciaHoy.value = respuesta.asistenciahoy;
        conductaSemanal.value = respuesta.conductasemanal;
        //console.log(arrayMarks.value);
    }).catch(function (error) {
        console.log(error);
    }); */
}

//console.log(filesForLevel.value.length)

//const formsLength = computed(() => filesForLevel.value.length)
//const existFilesForLevel = filesForLevel.value;
//console.log(formsLength)
//if (formsLength > 0) {
//isModalFiles.value = true
//} 

//onst app = getCurrentInstance()
//const constGlobal = app.appContext.config.globalProperties.confGlobalStr
//app.provide('progressBar', app.config.globalProperties.$Progress)
//console.log(constGlobal);

//const { proxy } = getCurrentInstance();
//console.log(proxy.versionApp)
//const globali = proxy.confGlobal
//console.log(globali)

//const props = defineProps({
//confGlobalVal: confGlobal.value
//});

/*
// LRR
//const confGlobal = props.connstantes
const confGlobalVal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobalVal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});

console.log(confGlobalVal.value);
*/

//const confGlobal = ref($confGlobal)

//onMounted(() => this.confGlobal)

//confGlobalVal.value = constantes

//console.log(confGlobalVal.INICIO_SHOW_MODAL_MENSAJE);

//const confGlobalVal = getConstantes
//confGlobalVal = constantes
//console.log(confGlobalVal);

//let rawData = confGlobalVal.value;

//if (isProxy(confGlobalVal.value)){
//rawData = toRaw(confGlobalVal.value)
//console.log('ProxyLe: ', rawData)
//}

//const reqObject = JSON.parse(JSON.stringify(confGlobalVal.value));
//console.log('request', reqObject);
//console.log(props.confGlobal);

// LRR usar constanteApi /************************************************************************** Reviasr constantes en script pendiente  */
//let constGlobal = 'Hola'
/*const getConstantes = async() => {
  try {
    //- LRR const resp = await constanteApi.get('/global')
    //console.log(resp)
    const { data } = await constanteApi.get('/global')
    const { constantes } = data
    console.log(constantes)
    const constGlobal = 'Good'

  } catch (error) {
    console.log('Error al consultar constantes', error)
    throw error
  }
}
getConstantes()
*/
//console.log(constGlobal.value)


const isModalInicioActive = ref(true)
//if (confGlobal.INICIO_SHOW_MODAL_MENSAJE == '1') {
//isModalInicioActive.value = 1;
//}
const isModalFullActive = ref(false);
const modalFullSrc = ref('');

const isConfirm = () => {
    //cleanVal()
}
const isCancel = () => {
    cleanVal()
}
const showingTabDropdown = ref(false);

const cleanVal = () => {
    modalFullSrc.value = ''

}

/*let myRadios = document.getElementsByName('tabs2');
let setCheck;
let x = 0;
for (x = 0; x < myRadios.length; x++) {
    myRadios[x].onclick = function () {
        if (setCheck != this) {
            setCheck = this;
        } else {
            this.checked = false;
            setCheck = null;
        }
    };
}
*/

const data = {
    "files": [
        { "id": 1, "course": "Matemática", "maestro": "Lenin Rivas", "progress": 71 },
        { "id": 2, "course": "Lenguaje", "maestro": "Lucy Farroñay", "progress": 68 },
        { "id": 3, "course": "Arte", "maestro": "Jorge el Curioso", "progress": 49 },
        { "id": 3, "course": "Sociedad y Ambiente", "maestro": "Dora la Exploradora", "progress": 36 },

    ]
};
const data2 = {
    "files": [
        { "id": 1, "course": "Física", "maestro": "Juan Rivas", "progress": 80 },
        { "id": 2, "course": "Química", "maestro": "Eduardo Otero", "progress": 70 },
        { "id": 3, "course": "Biología", "maestro": "Pilar Ramirez", "progress": 49 },
        { "id": 3, "course": "Educación física", "maestro": "Leon Van Damme", "progress": 31 },

    ]
};

// Slider >>> OBSOLETO Eliminado

</script>

<template>

    <Head title="Inicio" />

    <BreezeAuthenticatedLayout>
        <!-- <div class="group fixed bottom-0 right-0 p-4 flex items-end justify-end w-24 h-24 ">
           
            <div class="text-white shadow-lg flex items-center justify-center p-4 rounded-full bg-blue-600 z-50 absolute  ">
                <BaseIcon :path="mdiPlus" :size="26" class="text-white" />
            </div>
            
            <div class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-y-0 group-hover:scale-y-100 group-hover:-translate-x-16 flex  p-3 hover:p-3 bg-green-300 scale-100 hover:bg-green-400 text-white">
                <BaseIcon :path="mdiChatProcessingOutline" :size="26" class="text-white" />
            </div>
            
            <div class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-x-0 group-hover:scale-x-100 group-hover:-translate-y-16  flex  p-3 hover:p-3 bg-blue-300 hover:bg-blue-400  text-white">
                <BaseIcon :path="mdiCogOutline" :size="26" class="text-white" />
            </div>
           
            <div class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-x-0 group-hover:scale-x-100 group-hover:-translate-y-14 group-hover:-translate-x-14   flex  p-3 hover:p-3 bg-yellow-300 hover:bg-yellow-400 text-white">
                <BaseIcon :path="mdiCogOutline" :size="26" class="text-white" />
            </div>
        </div> -->

        <!-- Botón Ayuda -->
        <div class="group fixed bottom-0 right-0 p-4 flex items-end justify-center w-24 h-36">
            <!-- 6 secretaria, 5 coordinador, 4, admincoord 3 adminsitrador, 2 gerencial, TI -->
            <template v-if="$page.props.auth.user.id_rol <= 6">
                <template v-if="confGlobal.value.MAIN_SUPPORT_CHAT_URL">
                    <div class="text-white shadow-lg flex items-center justify-center p-4 rounded-full bg-blue-600 hover:bg-blue-800 z-50 absolute" title="Necesitas ayuda?">
                        <BaseIcon :path="mdiChatQuestionOutline" :size="26" class="text-white" />
                    </div>
                    <a :href="confGlobal.value.MAIN_SUPPORT_CHAT_URL" target="_blank" class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-y-0 group-hover:scale-y-100 group-hover:-translate-y-16 flex  p-3 hover:p-3 bg-green-500 scale-100 hover:bg-green-600 text-white" style="margin-bottom: 52px">
                        <BaseIcon :path="mdiChatProcessingOutline" :size="26" class="text-white" />
                    </a>
                    <Link :href="route('help')" class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-y-0 group-hover:scale-y-100 group-hover:-translate-y-16 flex  p-3 hover:p-3 bg-red-500 scale-100 hover:bg-red-700 text-white">
                        <BaseIcon :path="mdiHelp" :size="26" class="text-white" />
                    </Link>
                </template>
                <template v-else>
                    <Link :href="route('help')" class="text-white shadow-lg flex items-center justify-center p-4 rounded-full bg-red-600 hover:bg-red-800 z-50 absolute" title="Necesitas ayuda?">
                        <BaseIcon :path="mdiHelp" :size="26" class="text-white" />
                    </Link>
                </template>
            </template>
            <!-- Estudiante o apoderado -->
            <template v-else-if="($page.props.auth.user.id_rol == 8 || $page.props.auth.user.id_rol == 9)">
                <template v-if="confGlobal.value.STUDENT_SUPPORT_CHAT_URL">
                    <div class="text-white shadow-lg flex items-center justify-center p-4 rounded-full bg-blue-600 hover:bg-blue-800 z-50 absolute" title="Necesitas ayuda?">
                        <BaseIcon :path="mdiChatQuestionOutline" :size="26" class="text-white" />
                    </div>
                    <a :href="confGlobal.value.STUDENT_SUPPORT_CHAT_URL" target="_blank" class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-y-0 group-hover:scale-y-100 group-hover:-translate-y-16 flex  p-3 hover:p-3 bg-green-500 scale-100 hover:bg-green-600 text-white" style="margin-bottom: 52px">
                        <BaseIcon :path="mdiChatProcessingOutline" :size="26" class="text-white" />
                    </a>
                    <Link :href="route('help')" class="absolute rounded-full transition-all duration-[0.2s] ease-out scale-y-0 group-hover:scale-y-100 group-hover:-translate-y-16 flex  p-3 hover:p-3 bg-red-500 scale-100 hover:bg-red-700 text-white">
                        <BaseIcon :path="mdiHelp" :size="26" class="text-white" />
                    </Link>
                </template>
                <template v-else>
                    <Link :href="route('help')" class="text-white shadow-lg flex items-center justify-center p-4 rounded-full bg-red-600 hover:bg-red-800 z-50 absolute" title="Necesitas ayuda?">
                        <BaseIcon :path="mdiHelp" :size="26" class="text-white" />
                    </Link>
                </template>
            </template>
            <!-- Todos los demas -->
            <template v-else>
                <Link :href="route('help')" class="text-white shadow-lg flex items-center justify-center p-4 rounded-full bg-red-600 hover:bg-red-800 z-50 absolute" title="Necesitas ayuda?">
                    <BaseIcon :path="mdiHelp" :size="26" class="text-white" />
                </Link>
            </template>
            
        </div>

        <!-- Modal de comunicados si moodal mensaje está activo -->
        <template v-if="confGlobal.value.INICIO_SHOW_MODAL_MENSAJE == '1'">
            <CardBoxModalPopup v-model="isModalInicioActive" title="Aviso" size-modal="modal-3" noPadding class="p-4" hasCancel>
                <div class="grid grid-cols-1 h-full">
                    <!-- <div class="md:col-span-2 md:h-full h-48 col-span-1 rounded-t-lg bg-cover bg-center md:rounded-none md:rounded-l-lg"
                        style="background-image: url(/img/dashboard/popup-01.jpg);">

                    </div>
                    <div class="md:col-span-3 col-span-1 p-6 items-center h-full flex bg-cover bg-center md:rounded-r-lg rounded-b-lg"
                        style="background-image: url(/img/dashboard/bg-popup.png);">
                        <div>
                            <div class="mb-8">
                                <p class="text-sm text-gray-600 flex items-center">
                                    Estamos Contigo.
                                </p>
                                <div class="text-gray-900 font-bold lg:text-2xl text-xl mb-2">
                                    Volverte a ver ¡Nos emociona!
                                </div>
                                <p class="text-gray-700 lg:text-base text-sm">Nos hace muy felices tenerte de regreso. Si
                                    eres alumno
                                    nuevo, sabemos que lo disfrutaras al máximo.
                                    Con nosotros podras obtener la mejor modalidad de estudios para tus beneficios.
                                    <br>
                                    <br>
                                    ¿Tienes dudas?
                                </p>
                            </div>
                            <div class="flex items-center">
                                <a :href="route('help')" class="btn btn-rose mb-4">Clic Aquí</a>
                            </div>
                        </div>

                    </div> -->
                    <div class="col-span-1 p-6 h-full flex bg-cover bg-center rounded-lg" style="background-image: url(/img/dashboard/bg-popup.png);">
                        <div class="w-full">

                            <div class="text-gray-900 font-bold lg:text-2xl text-xl mb-4">
                                Anuncios
                            </div>
                            <div class="grid grid-cols-1 gap-3 h-[450px] mb-4 overflow-y-auto">
                                <div class="border rounded-md p-3 bg-white">
                                    <div class="flex justify-between mb-2">
                                        <div>
                                            <h1 class="font-semibold text-base">Dirección</h1>
                                        </div>
                                        <div class="flex items-center">
                                            <BaseIcon :path="mdiClockTimeEight" :size="20" class="text-lime-400 mr-2" />
                                            <p class="text-xs">03/10 18:50</p>
                                        </div>
                                    </div>
                                    <p class="text-sm">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum, libero!</p>
                                </div>
                                <div class="border rounded-md p-3 bg-white">
                                    <div class="flex justify-between mb-2">
                                        <div>
                                            <h1 class="font-semibold text-base">Dirección</h1>
                                        </div>
                                        <div class="flex items-center">
                                            <BaseIcon :path="mdiClockTimeEight" :size="20" class="text-lime-400 mr-2" />
                                            <p class="text-xs">03/10 18:50</p>
                                        </div>
                                    </div>
                                    <p class="text-sm">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum, libero!</p>
                                </div>
                                <div class="border rounded-md p-3 bg-white">
                                    <div class="flex justify-between mb-2">
                                        <div>
                                            <h1 class="font-semibold text-base">Dirección</h1>
                                        </div>
                                        <div class="flex items-center">
                                            <BaseIcon :path="mdiClockTimeEight" :size="20" class="text-lime-400 mr-2" />
                                            <p class="text-xs">03/10 18:50</p>
                                        </div>
                                    </div>
                                    <p class="text-sm">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum, libero!</p>
                                </div>
                                <div class="border rounded-md p-3 bg-white">
                                    <div class="flex justify-between mb-2">
                                        <div>
                                            <h1 class="font-semibold text-base">Dirección</h1>
                                        </div>
                                        <div class="flex items-center">
                                            <BaseIcon :path="mdiClockTimeEight" :size="20" class="text-lime-400 mr-2" />
                                            <p class="text-xs">03/10 18:50</p>
                                        </div>
                                    </div>
                                    <p class="text-sm">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum, libero!</p>
                                </div>
                                <div class="border rounded-md p-3 bg-white">
                                    <div class="flex justify-between mb-2">
                                        <div>
                                            <h1 class="font-semibold text-base">Dirección</h1>
                                        </div>
                                        <div class="flex items-center">
                                            <BaseIcon :path="mdiClockTimeEight" :size="20" class="text-lime-400 mr-2" />
                                            <p class="text-xs">03/10 18:50</p>
                                        </div>
                                    </div>
                                    <p class="text-sm">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nostrum, libero!</p>
                                </div>
                                
                            </div>
                            <div class="flex items-center">
                                <a :href="route('help')" class="btn btn-rose mb-0">100% Leido</a>
                            </div>
                        </div>

                    </div>
                </div>
            </CardBoxModalPopup>

        </template>

        <!-- Vista previa Modal -->
        <CardBoxModal v-model="isModalFullActive" title="Vista previa" sizeModal="full" hasCancel><!-- tien el botón de cancelar superior-->
            <div class="flex justify-center w-full">
                <embed :src="modalFullSrc" class="min-h-[80vh] max-h-[80vh] lg:min-h-[80vh] w-full"><!-- w-full es para documetnos w-auto para imágenes-->
            </div>
        </CardBoxModal>

        
        <template #header>
            <PageHeader :title="'Hola ' + $page.props.auth.user.name" />
        </template>

        <!-- Body -->
        <div class="py-8 lg:py-10">
            <!--Marcaddores -->
            <div class="sm:px-6 lg:px-8 px-4 mx-auto pb-4">
                <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
                    <div class="lg:col-span-4 bg-white rounded-md shadow-lg border p-4">
                        <div class="mb-4 flex justify-between">
                            <h3 class="text-xl font-bold"> Marcadores

                            </h3>
                            <!-- <p class="mb-8"></p> -->
                            <Link :href="route('config-mark')">
                            <BaseButton color="info" :icon="mdiStarOutline" small label="Ver Lista" class="inline-flex" />
                            </Link>
                        </div>

                        <div class="grid lg:grid-cols-4 md:grid-cols-2 md:gap-4 gap-3">
                            <!-- Escritorio de Estudiante o apoderado-->
                            <template v-if="$page.props.auth.user.rol_type == 'estudiante' || $page.props.auth.user.rol_type == 'apoderado'">

                                <div class="flex items-star justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('student-courses')">
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-red-500 focus:shadow-outline hover:bg-red-700">
                                                <BaseIcon :path="mdiBook" :size="24" />
                                            </div>
                                        </div>

                                        <div>
                                            <h3 class="font-semibold text-base">Mis cursos</h3>
                                            <p class="text-sm">Revisa tus guías, tareas y otros</p>
                                        </div>
                                    </div>
                                    </Link>
                                </div>

                                <div class="flex items-start justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('student-courses')">
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-lime-500 focus:shadow-outline hover:bg-lime-700">
                                                <BaseIcon :path="mdiCalendarCheckOutline" :size="28" />
                                            </div>
                                        </div>

                                        <div>
                                            <h3 class="font-semibold text-base">Mis tareas ({{ countTareaWithOutResp }})</h3>
                                            <p class="text-sm"> Pendientes de entrega</p>
                                        </div>
                                    </div>
                                    </Link>
                                </div>

                                <div class="flex items-start justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('student-agenda')">
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-yellow-500 focus:shadow-outline hover:bg-yellow-700">
                                                <BaseIcon :path="mdiCalendarAccount" :size="28" />
                                            </div>
                                        </div>

                                        <div>
                                            <h3 class="font-semibold text-base">Mi agenda</h3>
                                            <p class="text-sm">Diario de asistencia y observaciones</p>
                                        </div>
                                    </div>
                                    </Link>
                                </div>

                                <div class="flex items-start justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-sky-500 focus:shadow-outline hover:bg-sky-700">
                                                <BaseIcon :path="mdiClockTimeThreeOutline" :size="28" />
                                            </div>
                                        </div>

                                        <div>
                                            <h3 class="font-semibold text-base">Asistencia de hoy</h3>
                                            <p class="text-sm">{{ asistenciaHoy }}</p>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div class="flex items-start justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-slate-500 focus:shadow-outline hover:bg-slate-700">
                                                <BaseIcon :path="mdiAccountStar" :size="28" />
                                            </div>
                                        </div>

                                        <div>
                                            <h3 class="font-semibold text-base">Conducta semanal</h3>
                                            <p class="text-sm">{{ conductaSemanal }}</p>
                                        </div>
                                    </div>
                                    
                                </div>
                                <!-- Record de pagos -->
                                <!-- <div class="flex items-start justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('student-agenda')">
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-emerald-500 focus:shadow-outline hover:bg-emerald-700">
                                                <BaseIcon :path="mdiCashFast" :size="28" />
                                            </div>
                                        </div>

                                        <div>
                                            <h3 class="font-semibold text-base">Record de Pagos</h3>
                                            <p class="text-sm">Super super mala</p>
                                        </div>
                                    </div>
                                    </Link>
                                </div> -->
                                <!-- El estudiante que no paga no tiene acceso al sistema -->
                                <div v-if="publicarNotas" class="flex items-start justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('calification-libreta')" target="_blank">
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-purple-500 focus:shadow-outline hover:bg-purple-700">
                                                <BaseIcon :path="mdiFileDocument" :size="28" />
                                            </div>
                                        </div>

                                        <div>
                                            <h3 class="font-semibold text-base">Libreta de Notas</h3>
                                            <p class="text-sm">Vista previa</p>
                                        </div>
                                    </div>
                                    </Link>
                                </div>

                            </template>
                            <!-- Diseñadora -->
                            <template v-else-if="$page.props.auth.user.rol_type == 'diseño'">
                                <div class="flex items-star justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('file-listado', { 'type': 'file_guideforcourse' })">
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-red-500 focus:shadow-outline hover:bg-red-700">
                                                <BaseIcon :path="mdiGoogleClassroom" :size="24" />
                                            </div>
                                        </div>

                                        <div>
                                            <h3 class="font-semibold text-base">Slides</h3>
                                            <p class="text-sm">Cargar Slides o promociones</p>
                                        </div>
                                    </div>
                                    </Link>
                                </div>
                            </template>
                            
                            
                            
                            <!-- Administradores -->
                            <template v-else>
                                <div class="flex items-star justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('areaFinanciera', {'action': 'view_estados_cuenta'})">
                                        <div class="flex gap-3">
                                            <div>
                                                <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-red-500 focus:shadow-outline hover:bg-red-700">
                                                    <BaseIcon :path="mdiStarOutline" :size="24" />
                                                </div>
                                            </div>
                                            <div>
                                                <h3 class="font-semibold text-base">Estados de cuenta</h3>
                                                <p class="text-sm">Listado</p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div class="flex items-star justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                    <Link :href="route('file-listado', { 'type': 'file_guideforcourse' })">
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-red-500 focus:shadow-outline hover:bg-red-700">
                                                <BaseIcon :path="mdiGoogleClassroom" :size="24" />
                                            </div>
                                        </div>

                                        <div>
                                            <h3 class="font-semibold text-base">Slides</h3>
                                            <p class="text-sm">Cargar Slides</p>
                                        </div>
                                    </div>
                                    </Link>
                                </div>
                            </template>

                            <!-- Iteración de marcadores -->
                            <div v-if="arrayMarks.length" v-for="obj in arrayMarks" :key="obj.id" class="flex items-star justify-between rounded-md p-2 hover:bg-gray-100 dark:hover:bg-gray-600/40 cursor-pointer user-select">
                                <a v-if="obj.target" :href="obj.url" target="_blank">
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 focus:shadow-outline" :class="'bg-'+obj.color+'-500 hover:bg-'+obj.color+'-700'">
                                                <BaseIcon :path="mdiStarShootingOutline" :size="24" />
                                            </div>
                                        </div>
                                        <div>
                                            <h3 class="font-semibold text-base">{{ obj.label }}</h3>
                                            <p class="text-sm">{{ obj.description }}L</p>
                                        </div>
                                    </div>
                                </a>
                                <Link v-else :href="obj.url">
                                    <div class="flex gap-3">
                                        <div>
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 focus:shadow-outline" :class="'bg-'+obj.color+'-500 hover:bg-'+obj.color+'-700'">
                                                <BaseIcon :path="mdiStarOutline" :size="24" />
                                            </div>
                                        </div>
                                        <div>
                                            <h3 class="font-semibold text-base">{{ obj.label }}</h3>
                                            <p class="text-sm">{{ obj.description }}</p>
                                        </div>
                                    </div>
                                </Link>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Contenidos -->
            <div class="sm:px-6 lg:px-8 px-4 mx-auto pb-4">
                <!-- ESTUDIANTES -->
                <div v-if="$page.props.auth.user.rol_type == 'estudiante' || $page.props.auth.user.rol_type == 'apoderado'" class="grid grid-cols-1 lg:grid-cols-4 2xl:grid-cols-8 gap-4">

                    <!-- <div class="col-span-3 bg-white rounded-lg shadow-lg p-6">
                        <SectionTitleLineWithButtonUnens title="Gráfica de competencias">
                            <select @change="listarChartCalification(this.value)">
                                <option value="" disabled>Escoja el Bimestre</option>
                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR+'B1'" selected>Primer Bimestre</option>
                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR+'B2'" selected>Segundo Bimestre</option>
                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR+'B3'" selected>Tercer Bimestre</option>
                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR+'B4'" selected>Cuarto Bimestre</option>
                            </select>
                        </SectionTitleLineWithButtonUnens>
                        <CardBox class="p-0">
                            {{ chartCalifications }}
                            <div v-if="chartCalifications">
                                <radar-chart :data="chartCalifications"
                                    class="h-96" />
                            </div>
                        </CardBox>
                    </div> -->
                    <div class="col-span-1 lg:col-span-2 2xl:col-span-3 bg-white rounded-lg shadow-lg p-6">

                        <!-- EAP -->
                        <div v-if="haveEAP" class="font-bold text-xl mb-3">Simulacro tipo examen de admisión</div>
                        <div v-if="haveEAP" class="grid">
                            <div v-if="arrayAdmisionPuntaje.length" v-for="client in arrayAdmisionPuntaje" :key="client.id" class="grid grid-cols-4 bg-gray-100 py-2 px-4 mb-3 rounded-lg">

                                <div class="col-span-2 md:col-span-3 inline-flex items-center pt-2">
                                    <!-- <BaseIcon v-if="client.type == 'PDF'" :path="mdiPaperclip" :size="32" class="text-red-600 mr-2" />
                                    <BaseIcon v-else :path="mdiPaperclip" :size="32" class="text-lime-600 mr-2" /> -->
                                    <span>
                                        {{ client.ref_ciclo }}
                                    </span>
                                    <span class="ml-2">

                                        {{ client.label_eap }}
                                    </span>
                                    <span class="ml-2">

                                        {{ client.puntaje }}
                                    </span>
                                    <span class="ml-2">
                                        <small v-if="client.resultado == '1'" class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 bg-emerald-500 border-emerald-500 text-white last:mr-0">
                                            <span>Ingresó</span>
                                        </small>
                                        <small v-else-if="client.resultado == '2'" class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 transition-colors focus:ring duration-150 border-yellow-600 dark:border-yellow-500 ring-yellow-300 dark:ring-yellow-700 bg-yellow-600 dark:bg-yellow-500 text-white last:mr-0">
                                            <span>Ausente</span>
                                        </small>
                                        <small v-else class="inline-flex items-center capitalize leading-none text-sm border rounded-full py-1.5 px-4 transition-colors focus:ring duration-150 border-red-600 dark:border-red-500 ring-red-300 dark:ring-red-700 bg-red-600 dark:bg-red-500 text-white last:mr-0">
                                            <span>No ingresó</span>
                                        </small>
                                    </span>
                                </div>
                                <BaseButtons v-if="confGlobal.value.INICIO_STUDENT_SHOW_PRINT_DIPLOMA == '1'" type="justify-start lg:justify-end" no-wrap>

                                    <BaseButton color="info" :icon="mdiPrinter" small :href="'/admisionpuntaje/diploma' + '?id=' + client.id" target="_blank" />


                                </BaseButtons>
                            </div>
                            <div v-else class="col-span-2 md:col-span-1 bg-gray-100 p-4 rounded-lg">
                                <span> Aun no se publica el puntaje …</span>
                            </div>
                        </div>

                        <!-- Archivos o documentos de inicio -->
                        <div class="font-bold text-xl mb-3">Documentos a tomar en cuenta</div>
                        <div class="grid gap-3">
                            <div v-if="filesForLevel.length" v-for="client in filesForLevel" :key="client.id" class="flex justify-between border p-3 rounded-md">
                                <div class=" inline-flex items-center text-base">
                                    <BaseIcon v-if="client.type == 'PDF'" :path="mdiPaperclip" :size="32" class="text-red-600 mr-2" />
                                    <BaseIcon v-else :path="mdiPaperclip" :size="32" class="text-lime-600 mr-2" />

                                    {{ client.name }}
                                </div>
                                <BaseButtons type="justify-start lg:justify-end" no-wrap>
                                    <BaseButton color="info" :icon="mdiEye" small @click="(isModalFullActive = true, modalFullSrc = '/documents/' + client.filepath + '/' + client.filename)" class="hidden lg:grid" />
                                    <BaseButton color="info" :icon="mdiDownload" small @click="" :href="route('file-download', { 'srctype': client.src_object_type, 'srcid': (client.src_object_id ? client.src_object_id : 0), 'filename': client.filename })" target="_blank" />
                                </BaseButtons>
                            </div>
                            <div v-else class="border p-3 rounded-md text-base">
                                <span> No existen registros …</span>
                            </div>
                        </div>


                    </div>

                    <!-- Agenda diaria -->
                    <!-- <div class="col-span-1 lg:col-span-2 2xl:col-span-5 rounded-lg overflow-hidden shadow-lg bg-white h-full lg:pb-6">
                        <div class="w-full pt-6 px-6">
                            <h1 class="text-gray-900 text-xl font-bold mb-4">Agenda de Tareas del dia</h1>
                        </div>
                        <div class="min-h-[280px] h-[calc(100%-68px)] p-0 lg:px-6 overflow-x-auto">
                            <div class="table w-full h-full min-w-[550px] overflow-x-auto">
                                <div class="table-header-group h-10">
                                    <div class="table-row bg-gray-700 text-white gap-2 text-sm lg:text-base">
                                        <div class="table-cell text-center align-middle lg:rounded-tl-md">Curso</div>
                                        <div class="table-cell text-center align-middle">Tema</div>
                                        <div class="table-cell text-center align-middle lg:rounded-tr-md">Tarea
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-group">
                                    <div class="table-row text-center text-xs lg:text-sm">
                                        <div class="table-cell align-middle border-b border-r border-l">Ingles</div>
                                        <div class="table-cell align-middle border-b border-r">Lorem ipsum dolor sit amet.</div>
                                        <div class="table-cell align-middle border-b border-r">Lorem, ipsum.</div>
                                    </div>
                                    <div class="table-row text-center text-xs lg:text-sm">
                                        <div class="table-cell align-middle border-b border-r border-l">Algebra</div>
                                        <div class="table-cell align-middle border-b border-r">Lorem ipsum dolor sit amet.</div>
                                        <div class="table-cell align-middle border-b border-r " id="12active">Lorem, ipsum.
                                        </div>
                                    </div>
                                    <div class="table-row text-center text-xs lg:text-sm">
                                        <div class="table-cell align-middle border-b border-r border-l">Aptitud Verbal</div>
                                        <div class="table-cell align-middle border-b border-r">Lorem ipsum dolor sit amet.</div>
                                        <div class="table-cell align-middle border-b border-r">Lorem, ipsum.</div>
                                    </div>
                                    <div class="table-row text-center text-xs lg:text-sm">
                                        <div class="table-cell align-middle border-b border-r border-l">Ciencia</div>
                                        <div class="table-cell align-middle border-b border-r">Lorem ipsum dolor sit amet.</div>
                                        <div class="table-cell align-middle border-b border-r">Lorem, ipsum.</div>
                                    </div>
                                    <div class="table-row text-center text-xs lg:text-sm">
                                        <div class="table-cell align-middle border-b border-r border-l rounded-bl-md">Lenguaje
                                        </div>
                                        <div class="table-cell align-middle border-b border-r">Lorem ipsum dolor sit amet.</div>
                                        <div class="table-cell align-middle rounded-br-md border-b border-r">Lorem, ipsum.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div> -->
                    <!-- Rol de exámenes -->
                    <!-- <div class="col-span-1 lg:col-span-2 2xl:col-span-4 rounded-lg overflow-hidden shadow-lg bg-white h-full lg:pb-6">
                        <div class="w-full pt-6 px-6">
                            <h1 class="text-gray-900 text-xl font-bold mb-4">Roles de Examenes</h1>

                        </div>
                        <div class="min-h-[280px] h-[calc(100%-68px)] p-0 lg:px-6 overflow-x-auto">
                            <div class="table w-full h-full min-w-[550px] overflow-x-auto">
                                <div class="table-header-group h-10">
                                    <div class="table-row bg-gray-700 text-white gap-2 text-sm lg:text-base">
                                        <div class="table-cell text-center align-middle lg:rounded-tl-md">Fecha</div>
                                        <div class="table-cell text-center align-middle">Curso</div>
                                        <div class="table-cell text-center align-middle lg:rounded-tr-md">Observación
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-group">
                                    <div class="table-row text-center text-xs lg:text-sm">
                                        <div class="table-cell align-middle border-b border-r border-l">Lunes 07/10</div>
                                        <div class="table-cell align-middle border-b border-r">
                                            <div class="flex flex-row items-center w-full h-full">
                                                <div class="w-1/2 border-r">Matematica</div>
                                                <div class="w-1/2">Ingles</div>
                                            </div>
                                        </div>
                                        <div class="table-cell align-middle border-b border-r">Estudia infeliz</div>
                                    </div>
                                    <div class="table-row text-center text-xs lg:text-sm">
                                        <div class="table-cell align-middle border-b border-r border-l">Martes 08/10</div>
                                        <div class="table-cell align-middle border-b border-r">
                                            <div class="flex flex-row items-center w-full h-full">
                                                <div class="w-full">
                                                    Algebra
                                                </div>
                                            </div>
                                        </div>
                                        <div class="table-cell align-middle border-b border-r " id="12active">Lorem, ipsum.
                                        </div>
                                    </div>
                                    <div class="table-row text-center text-xs lg:text-sm">
                                        <div class="table-cell align-middle border-b border-r border-l">Miercoles 09/10</div>
                                        <div class="table-cell align-middle border-b border-r">
                                            <div class="flex flex-row items-center w-full h-full">
                                                <div class="w-full">
                                                    Aritmetica
                                                </div>
                                            </div>
                                        </div>
                                        <div class="table-cell align-middle border-b border-r">Lorem, ipsum.</div>
                                    </div>
                                    <div class="table-row text-center text-xs lg:text-sm">
                                        <div class="table-cell align-middle border-b border-r border-l">Jueves 10/10</div>
                                        <div class="table-cell align-middle border-b border-r">
                                            <div class="flex flex-row items-center w-full h-full">
                                                <div class="w-1/2 border-r">Ciencia</div>
                                                <div class="w-1/2">Biologia</div>
                                            </div>
                                        </div>
                                        <div class="table-cell align-middle border-b border-r">Lorem, ipsum.</div>
                                    </div>
                                    <div class="table-row text-center text-xs lg:text-sm">
                                        <div class="table-cell align-middle border-b border-r border-l rounded-bl-md">Viernes 11/10
                                        </div>
                                        <div class="table-cell align-middle border-b border-r">Historia</div>
                                        <div class="table-cell align-middle rounded-br-md border-b border-r">Lorem, ipsum.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <div class="col-span-1 lg:col-span-2 2xl:col-span-4 bg-white rounded-lg shadow-lg p-6">
                        <SectionTitleLineWithButtonUnens title="Gráfica de competencias">
                            <!-- <BaseButton :icon="mdiReload" color="whiteDark" @click="fillChartData" /> -->
                            <select v-model="chartSelectCiclo" @change="listarChartCalification(chartSelectCiclo)">
                                <option value="" disabled>Escoja el Bimestre</option>
                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR+'B1'" selected>Primer Bimestre</option>
                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR+'B2'" selected>Segundo Bimestre</option>
                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR+'B3'" selected>Tercer Bimestre</option>
                                <option :value="confGlobal.value.CICLO_ANIO_ESCOLAR+'B4'" selected>Cuarto Bimestre</option>
                            </select>
                        </SectionTitleLineWithButtonUnens>
                        <CardBox class="p-0">
                            <div v-if="chartCalifications">
                                <radar-chart :data="chartCalifications" class="h-96" />
                            </div>
                        </CardBox>
                    </div>
                    <!-- Agenda de alumno Horario -->
                    <!-- <div class="rounded-lg overflow-hidden shadow-lg bg-white h-full lg:pb-6">
                            <div class="w-full pt-6">
                                <h1 class="text-gray-900 text-xl font-bold mb-4 text-center">Horario de Clases</h1>

                            </div>
                            <div class="min-h-[280px] h-[calc(100%-68px)] p-0 lg:px-6 overflow-x-auto">
                                <div class="table w-full h-full min-w-[550px] overflow-x-auto">
                                    <div class="table-header-group h-10">
                                        <div class="table-row bg-gray-700 text-white gap-2 text-sm lg:text-base">
                                            <div class="table-cell text-center align-middle lg:rounded-tl-md">Hora</div>
                                            <div class="table-cell text-center align-middle">Lunes</div>
                                            <div class="table-cell text-center align-middle">Martes</div>
                                            <div class="table-cell text-center align-middle">Miercoles</div>
                                            <div class="table-cell text-center align-middle">Jueves</div>
                                            <div class="table-cell text-center align-middle lg:rounded-tr-md">Viernes
                                            </div>
                                        </div>
                                    </div>
                                    <div class="table-row-group">
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle bg-gray-100">08:00 am</div>
                                            <div class="table-cell align-middle border-b border-r">Lenguaje </div>
                                            <div class="table-cell align-middle border-b border-r">Matematica</div>
                                            <div class="table-cell align-middle border-b border-r">Arte </div>
                                            <div class="table-cell align-middle border-b border-r">Etc</div>
                                            <div class="table-cell align-middle border-b border-r">Etc</div>
                                        </div>
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle bg-gray-100">09:00 am</div>
                                            <div class="table-cell align-middle border-b border-r">Lenguaje </div>
                                            <div
                                                class="table-cell align-middle border-b border-r bg-blue-600 text-white">
                                                Matematica</div>
                                            <div class="table-cell align-middle border-b border-r">Arte </div>
                                            <div class="table-cell align-middle border-b border-r">Etc</div>
                                            <div class="table-cell align-middle border-b border-r " id="12active">Etc
                                            </div>
                                        </div>
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle bg-gray-100">10:00 am</div>
                                            <div class="table-cell align-middle border-b border-r">Recreo </div>
                                            <div class="table-cell align-middle border-b border-r">Recreo</div>
                                            <div class="table-cell align-middle border-b border-r">Recreo</div>
                                            <div class="table-cell align-middle border-b border-r">Recreo</div>
                                            <div class="table-cell align-middle border-b border-r">Recreo</div>
                                        </div>
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle bg-gray-100">11:00 am</div>
                                            <div class="table-cell align-middle border-b border-r">Lenguaje </div>
                                            <div class="table-cell align-middle border-b border-r">Matematica</div>
                                            <div class="table-cell align-middle border-b border-r">Arte </div>
                                            <div class="table-cell align-middle border-b border-r">Etc</div>
                                            <div class="table-cell align-middle border-b border-r">Etc</div>
                                        </div>
                                        <div class="table-row text-center text-xs lg:text-sm">
                                            <div class="table-cell align-middle bg-gray-100 rounded-bl-md">12:00 am
                                            </div>
                                            <div class="table-cell align-middle border-b border-r">Lenguaje </div>
                                            <div class="table-cell align-middle border-b border-r">Matematica</div>
                                            <div class="table-cell align-middle border-b border-r">Arte </div>
                                            <div class="table-cell align-middle border-b border-r">Etc</div>
                                            <div class="table-cell align-middle rounded-br-md border-b border-r">Etc
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div> -->
                </div>
                <!-- Card de portero-->
                <div v-else-if="$page.props.auth.user.rol_type == 'portero'" class="grid grid-cols-1 lg:grid-cols-4 2xl:grid-cols-8 gap-4">
                    <div class="col-span-1 lg:col-span-4 2xl:col-span-4 bg-white rounded-lg shadow-lg p-6">
                        <div class="flex justify-center">
                            <div class="rounded-lg overflow-hidden shadow-lg bg-white md:min-h-[385px]  w-full lg:w-3/4 p-6">

                                <div class="text-center">
                                    <h5 class="text-gray-900 text-xl font-bold mb-5">Registro de Asistencia</h5>
                                </div>
                                <div>
                                    <div class="flex items-center w-full h-[275px]">
                                        <div class="grid grid-cols-2 gap-4 text-center w-full">
                                            <input class="col-span-2 border border-gray-200 rounded-md p-3 text-center [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" type="number" placeholder="Ingresar ID" required>

                                            <div class="col-span-2 md:col-span-1 lg:col-span-1 flex flex-row border border-gray-200 hover:bg-gray-200 hover:border-gray-300 rounded-md  items-center">
                                                <label for="04" class="w-full p-4">
                                                    <div class="flex items-center">
                                                        <div>
                                                            <input type="radio" id="04" name="tardanza2">
                                                        </div>
                                                        <div class="w-full">Tardanza</div>
                                                        <div class="flex items-center">
                                                            <BaseIcon :path="mdiClockRemove" :size="24" :color="red" />
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                            <div class="col-span-2 md:col-span-1 lg:col-span-1 flex flex-row border border-gray-200 hover:bg-gray-200 hover:border-gray-300 rounded-md  items-center">
                                                <label for="03" class="w-full p-4">
                                                    <div class="flex items-center">
                                                        <div>
                                                            <input type="radio" id="03" name="tardanza2">
                                                        </div>
                                                        <div class="w-full">Tardanza Justificada</div>
                                                        <div class="flex items-center">
                                                            <BaseIcon :path="mdiClockCheck" :size="24" />
                                                        </div>
                                                    </div>
                                                </label>
                                            </div>
                                            <div class="col-span-2">
                                                <button class="btn btn-rose w-full p-4">
                                                    Enviar registro
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Maestro Tutor Coordinador-->
                <div v-else-if="$page.props.auth.user.rol_type == 'maestro' || $page.props.auth.user.rol_type == 'tutor' || $page.props.auth.user.rol_type == 'coordinador'" class="grid grid-cols-1 lg:grid-cols-4 2xl:grid-cols-8 gap-4">

                    <!-- info de asistencia a todos menos estudiantes o padres -->
                    <div class="col-span-1 lg:col-span-3 2xl:col-span-2 h-full">
                        <div v-if="arrayAsistencia && arrayAsistencia.length" class="rounded-lg overflow-hidden shadow-lg bg-white h-full p-6 flex items-center w-full">
                            <div v-for="asistencia in arrayAsistencia" class="w-full">
                                <div class="w-full" title="Información mostrada hasta donde el responsable de asistencia haya cargado las marcaciones">
                                    <small class="text-gray-900 font-bold mb-4 text-left">
                                        Asistencia {{ asistencia.name }}
                                    </small>
                                    <!-- <p class="text-gray-700 text-base mb-4">
                            Precisemos la asistencia de los alumnos.
                        </p> -->
                                </div>
                                <div class="w-full">
                                    <div class="grid grid-cols-6 rounded-md mb-4 p-2 hover:bg-gray-50 border" :title="(asistencia.records.justificada ? 'Justificadas: ' + asistencia.records.justificada + ' \n Fechas: ' + asistencia.records.justificadadet : '')">
                                        <div class="flex items-center">
                                            <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-green-600 bg-green-100">
                                                <BaseIcon :path="mdiCheckBold" :size="20" />
                                            </div>

                                        </div>
                                        <div class="col-span-3">
                                            <h6 class="text-base font-bold mb-2"> Normal</h6>
                                            <div class="w-full bg-gray-200 rounded-full h-1.5 ">
                                                <div class="bg-green-500 h-1.5 rounded-full" :style="'width: ' + (asistencia.records.asistencia * 100 / asistencia.records.diaslaborales) + '%'">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-span-2">
                                            <div class="flex items-center justify-end h-full">
                                                <div class="flex items-center p-1 border border-gray-300 rounded">
                                                    <span class="text-sm">{{ asistencia.records.asistencia }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid grid-cols-6 rounded-md mb-4 p-2 hover:bg-gray-50 border" :title="(asistencia.records.faltas ? 'Fechas: ' + asistencia.records.faltadet : '')">
                                        <div class="flex items-center">
                                            <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-red-600 bg-red-100">
                                                <BaseIcon :path="mdiCloseThick" :size="20" />
                                            </div>

                                        </div>
                                        <div class="col-span-3">
                                            <h6 class="text-base font-bold mb-2"> Faltas</h6>
                                            <div class="w-full bg-gray-200 rounded-full h-1.5">
                                                <div class="bg-red-500 h-1.5 rounded-full" :style="'width: ' + (asistencia.records.faltas * 100 / asistencia.records.diaslaborales) + '%'">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-span-2">
                                            <div class="flex items-center justify-end h-full">
                                                <div class="flex items-center p-1 border border-gray-300 rounded">
                                                    <span class="text-sm">{{ asistencia.records.faltas }}</span><!-- 23 -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid grid-cols-6 rounded-md mb-4 p-2 hover:bg-gray-50 border">
                                        <div class="flex items-center">
                                            <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-yellow-600 bg-yellow-100">
                                                <BaseIcon :path="mdiMinusThick" :size="20" />
                                            </div>

                                        </div>
                                        <div class="col-span-3">
                                            <h6 class="text-base font-bold mb-2"> Tardanza</h6>
                                            <div class="w-full bg-gray-200 rounded-full h-1.5 ">
                                                <div class="bg-yellow-400 h-1.5 rounded-full" :style="'width: ' + (asistencia.records.tardanzas * 100 / asistencia.records.diaslaborales) + '%'">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-span-2">
                                            <div class="flex items-center justify-end h-full">
                                                <div class="flex items-center p-1 border border-gray-300 rounded">
                                                    <span class="text-sm">{{ asistencia.records.tardanzas }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="grid grid-cols-6 rounded-md mb-4 p-2 hover:bg-gray-50 border">
                                        <div class="flex items-center">
                                            <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-sky-600 bg-sky-100">
                                                <BaseIcon :path="mdiChevronRight" :size="20" />
                                            </div>

                                        </div>
                                        <div class="col-span-3">
                                            <h6 class="text-base font-bold mb-2"> Sal. Temp.</h6>
                                            <div class="w-full bg-gray-200 rounded-full h-1.5 ">
                                                <div class="bg-sky-400 h-1.5 rounded-full" :style="'width: ' + (asistencia.records.salidas_temprano * 100 / asistencia.records.diaslaborales) + '%'">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-span-2">
                                            <div class="flex items-center justify-end h-full">
                                                <div class="flex items-center p-1 border border-gray-300 rounded">
                                                    <span class="text-sm">{{ asistencia.records.salidas_temprano }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="rounded-lg overflow-hidden shadow-lg bg-white h-full p-6 flex items-center w-full">
                            <div class="w-full">
                                <div class="w-full">
                                    <h3 class="text-gray-900 text-xl font-bold mb-4 text-left">
                                        Asistencia
                                    </h3>
                                    <!-- <p class="text-gray-700 text-base mb-4">
                            Precisemos la asistencia de los alumnos.
                        </p> -->
                                </div>
                                <div class="w-full">
                                    <div class="flex justify-between rounded-md mb-4 p-2 hover:bg-gray-50 border">
                                        <div class="flex items-center">
                                            <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-green-600 bg-green-100">
                                                <BaseIcon :path="mdiCheckBold" :size="20" />
                                            </div>

                                        </div>
                                        <div class="w-full mx-3">
                                            <h6 class="text-base font-bold mb-2"> Normal</h6>
                                            <div class="w-full bg-gray-200 rounded-full h-1.5 ">
                                                <div class="bg-green-500 h-1.5 rounded-full" style="width: 0%">
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="w-12 flex items-center rounded justify-center h-full p-1 border border-gray-300 ">
                                                <span class="text-sm">0</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex justify-between rounded-md mb-4 p-2 hover:bg-gray-50 border">
                                        <div class="flex items-center">
                                            <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-red-600 bg-red-100">
                                                <BaseIcon :path="mdiCloseThick" :size="20" />
                                            </div>

                                        </div>
                                        <div class="w-full mx-3">
                                            <h6 class="text-base font-bold mb-2"> Faltas</h6>
                                            <div class="w-full bg-gray-200 rounded-full h-1.5">
                                                <div class="bg-red-500 h-1.5 rounded-full" :style="'width: ' + (cantFaltas * 100 / 23) + '%'">
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="w-12 flex items-center rounded justify-center h-full p-1 border border-gray-300">
                                                <span class="text-sm">{{ cantFaltas }}</span><!-- 23 -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex justify-between rounded-md mb-4 p-2 hover:bg-gray-50 border">
                                        <div class="flex items-center">
                                            <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-yellow-600 bg-yellow-100">
                                                <BaseIcon :path="mdiMinusThick" :size="20" />
                                            </div>

                                        </div>
                                        <div class="w-full mx-3">
                                            <h6 class="text-base font-bold mb-2"> Tardanza</h6>
                                            <div class="w-full bg-gray-200 rounded-full h-1.5 ">
                                                <div class="bg-yellow-400 h-1.5 rounded-full" :style="'width: ' + (cantTardanzas * 100 / 23) + '%'">
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div class="w-12 flex items-center rounded justify-center h-full p-1 border border-gray-300">
                                                <span class="text-sm">{{ cantTardanzas }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex justify-between rounded-md mb-4 p-2 hover:bg-gray-50 border">
                                        <div class="flex items-center">
                                            <div class="rounded-lg h-10 w-10 text-lg flex items-center justify-center text-sky-600 bg-sky-100">
                                                <BaseIcon :path="mdiChevronRight" :size="20" />
                                            </div>

                                        </div>
                                        <div class="w-full mx-3">
                                            <h6 class="text-base font-bold mb-2">Sal. Temp.</h6>
                                            <div class="w-full bg-gray-200 rounded-full h-1.5 ">
                                                <div class="bg-sky-400 h-1.5 rounded-full" :style="'width: ' + (cantTardanzas * 100 / 23) + '%'">
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <div class="w-12 flex items-center rounded justify-center h-full p-1 border border-gray-300">
                                                <span class="text-sm">{{ cantTardanzas }}</span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div v-else class="grid grid-cols-1 lg:grid-cols-4 2xl:grid-cols-8 gap-4">
                    <!-- Slide reubicar -->
                    <div class="col-span-1 lg:col-span-4 2xl:col-span-4 shadow-lg" v-if="confGlobal.value.INICIO_SHOW_SLIDE == '1'">
                        <Splide :options="{ rewind: true, perPage: 1, type: 'loop', autoplay: 'true', pagination: boolean = false, arrows: boolean = false, gap: '1em' }" class="rounded-lg">
                            <div class="splide__arrows"></div>
                            <SplideSlide class="rounded-lg">
                                <div class="bg-[url('/img/dashboard/slider-01.png')] bg-no-repeat bg-center bg-cover rounded-lg">
                                    <div class="rounded-lg bg-black/10" style="height: 385px"><!-- -+ bg-black/30-->
                                        <div class="md:w-1/2 py-20 lg:py-24 md:pl-24 px-10 object-fill text-white">
                                            <!-- <p class="font-bold text-sm uppercase">Vacaciones</p>
                                    <p class="text-3xl font-bold">Talleres</p>
                                    <p class="text-2xl mb-10 leading-none">Programas académicos y de aprendizaje por
                                        inicio de vacaciones.</p> -->
                                            <!-- <a href="#" class="btn btn-lg btn-rose mt-12">Eventos</a> --><!-- + mt-12 -->
                                        </div>
                                    </div>

                                </div>
                            </SplideSlide>
                            <SplideSlide class="rounded-lg">
                                <div class="bg-[url('/img/dashboard/slider-02.png')] bg-no-repeat bg-center bg-cover rounded-lg">
                                    <div class="rounded-lg bg-black/10" style="height: 385px"><!-- -+ bg-black/30-->
                                        <div class="md:w-1/2 py-20 lg:py-24 md:pl-24 px-10 object-fill text-white">
                                            <!-- <p class="font-bold text-sm uppercase">Se acaba el año</p>
                                    <p class="text-3xl font-bold">Matriculas 2023</p>
                                    <p class="text-2xl mb-10 leading-none">Realiza todas tus consultas por
                                        cualquiera de nuestros medios.</p> -->
                                            <!-- <a href="#" class="btn btn-lg btn-rose mt-12">Eventos</a> --><!-- + mt-12 -->
                                        </div>
                                    </div>
                                </div>
                            </SplideSlide>

                        </Splide>
                    </div>
                    <!-- ... -->


                    <!-- Ayuda -->
                    <!-- <div v-else class="col-span-1 sm:col-span-1 xl:col-span-1">
                        <div class="rounded-lg overflow-hidden shadow-lg bg-white md:min-h-[385px]">
                            <img class="w-full" src="/img/dashboard/calificaciones.png" alt="Sunset in the mountains">
                            <div class="p-6 mb-4">
                                <div>
                                    <div class="font-bold text-xl mb-2">Hola {{ $page.props.auth.user.name }}</div>
                                    <p class="text-gray-700 text-base mb-4">
                                        Necesitas ayuda ?
                                    </p>
                                    <Link :href="route('help')" class="btn btn-rose mb-4">Clic Aquí</Link>

                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="col-span-1 sm:col-span-1 lg:col-span-2 2xl:col-span-2 bg-white rounded-lg shadow-lg ">
                        <div class="flex flex-col md:flex-row xl:flex-col h-[350px] md:h[300px] xl:h-[385px]">
                            <div class="rounded-tl-lg rounded-tr-lg md:rounded-bl-lg md:rounded-tr-none xl:rounded-bl-none xl:rounded-tr-lg overflow-hidden shadow-lg  p-6 w-full md:w-1/2 xl:w-full h-1/2 md:h-full xl:h-1/2 bg-cover bg-center" style="background-image: url(/img/dashboard/calificaciones.png);">
                            </div>
                            <div class="rounded-br-lg rounded-bl-lg md:rounded-tr-lg md:rounded-bl-none xl:rounded-tr-none xl:rounded-bl-lg p-6 w-full md:w-1/2 xl:w-full h-1/2 md:h-full xl:h-1/2 flex items-center">
                                <div>
                                    <div class="font-bold text-xl mb-2">Hola {{ $page.props.auth.user.name }}</div>
                                    <p class="text-gray-700 text-base mb-4">
                                        Necesitas ayuda ?
                                    </p>
                                    <Link :href="route('help')" class="btn btn-rose mb-4">Clic Aquí</Link>

                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="col-span-1 sm:col-span-1 lg:col-span-2 2xl:col-span-2 bg-white rounded-lg shadow-lg ">
                        <div class="flex flex-col h-[350px] lg:h-full ">
                            <div class="rounded-tl-lg rounded-tr-lg overflow-hidden shadow-lg p-6 h-1/2 w-full bg-cover bg-center" style="background-image: url(/img/dashboard/calificaciones.png);">
                            </div>
                            <div class="rounded-br-lg rounded-bl-lg p-6 w-full flex items-center h-1/2">
                                <div>
                                    <div class="font-bold text-xl mb-2">Hola {{ $page.props.auth.user.name }}</div>
                                    <p class="text-gray-700 text-base mb-4">
                                        Necesitas ayuda ?
                                    </p>
                                    <Link :href="route('help')" class="btn btn-rose mb-4">Clic Aquí</Link>

                                </div>
                            </div>
                        </div>
                    </div> -->


                    <div v-if="confGlobal.value.SHOW_ERROR_PP == 1 && $page.props.auth.user.id_rol == 1" class="col-span-1 lg:col-span-2 2xl:col-span-4 bg-white rounded-lg shadow-lg p-6">
                        <h3 class="font-bold text-2xl md:text-6xl">ERROR PP 1301</h3>
                    </div>


                    <!-- Default trend type is info -->



                </div>
            </div>

        </div>
    </BreezeAuthenticatedLayout>
</template>